import { render, staticRenderFns } from "./CanceledOpportunities.vue?vue&type=template&id=3f6c6cf6&scoped=true&"
import script from "./CanceledOpportunities.vue?vue&type=script&lang=js&"
export * from "./CanceledOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./CanceledOpportunities.vue?vue&type=style&index=0&id=3f6c6cf6&prod&lang=css&"
import style1 from "./CanceledOpportunities.vue?vue&type=style&index=1&id=3f6c6cf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6c6cf6",
  null
  
)

export default component.exports